/**
 * What an inventory row's stock says about prescribing it, in ONE place. The medicine search's row
 * rendering and its choose path both read it, because deriving it twice is exactly how the keyboard
 * came to refuse a medicine the row was labelling "In stock": the second copy read a field that does
 * not exist (effectiveQuantity, not totalQuantity) and treated the advisory pending count as a
 * blocker. Applying a template reads it too, for the advice; the server refuses what is out.
 *
 * pendingQuantity is units on today's undispensed prescriptions. It is ADVISORY -- it colours a
 * "Reserved today" badge and nothing more. Only real stock blocks prescribing. The server judges
 * stock by the same rule (PrescriptionService.stockVerdict).
 */
export const stockStateFor = (med) => {
  const qty = med.totalQuantity ?? 0;
  const pending = med.pendingQuantity ?? 0;
  const effective = qty - pending;
  const isOut = qty <= 0 || med.status === 'OUT_OF_STOCK' || med.status === 'EXPIRED';
  const isReserved = !isOut && pending > 0 && effective <= 0;
  const isLow = !isOut && !isReserved
    && (med.status === 'LOW_STOCK' || med.status === 'NEAR_EXPIRY'
        || (med.threshold != null && effective <= med.threshold));
  return { qty, pending, effective, isOut, isReserved, isLow };
};
